// @flow
export const COMPONENT_NAME = 'dialog';

export const CONFIRM_DIALOG = `@${COMPONENT_NAME}/CONFIRM`;
export const ERROR_DIALOG = `@${COMPONENT_NAME}/ERROR`;
export const RESOLVE_DIALOG = `@${COMPONENT_NAME}/RESOLVE`;



// WEBPACK FOOTER //
// ./src/common/components/dialog/constants.js